import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function DownloadEventsList({ jsonDashboard }) {
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const events = useSelector((state) => state.events.events);

  const csvLabels = [
    { label: "Fecha", key: "fechaEvento" },
    { label: "Hora", key: "horaEvento" },
    { label: "Tipo", key: "type" },
    { label: "businessId", key: "businessId" },
    { label: "ID Evento", key: "iDEvento" },
    { label: "Nombre Evento", key: "nombreEvento" },
    { label: "Ciudad", key: "ciudadEvento" },
    { label: "Lugar", key: "lugarEvento" },
    { label: "Logo", key: "logoEvento" },
  ];

  const [csvReport, setCSVReport] = useState([]);

  useEffect(() => {
    if (events) {
      generateCSV(events);
    }
  }, [events]);

  function generateCSV(data) {
    const report = Object.values(data || {})
      .sort((a, b) => {
        if (a.fechaEvento > b.fechaEvento) return 1;
        if (a.fechaEvento < b.fechaEvento) return -1;
        return 0;
      })
      .map((item) => ({
        ...item,
      }));

    setCSVReport(report);
  }

  function cleanCSVValue(value) {
    if (value === null || value === undefined) {
      return "";
    }

    return String(value)
      .replace(/\r?\n|\r/g, " ") // elimina saltos de línea internos
      .replace(/"/g, '""') // escapa comillas
      .trim();
  }

  function downloadCSV() {
    const separator = ",";

    const header = csvLabels
      .map((column) => `"${cleanCSVValue(column.label)}"`)
      .join(separator);

    const rows = csvReport.map((item) => {
      return csvLabels
        .map((column) => {
          const value = item[column.key];
          return `"${cleanCSVValue(value)}"`;
        })
        .join(separator);
    });

    const csvContent = [header, ...rows].join("\r\n");

    const BOM = "\uFEFF";

    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Lista de eventos Dashport.csv");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }
  if (!events) {
    return <div />;
  }

  return (
    <div>
      {events && atleteAccount?.perfil === 1 && (
        <Button
          variant="contained"
          color="primary"
          onClick={downloadCSV}
        >
          Descargar CSV de eventos
        </Button>
      )}
    </div>
  );
}